import Http from '../API'

export default {
  state: {
    servers: [],
    auth: null,
    user: {},
    load_page: true,
    unkn_group: {},
    unkn_server: {},
    visibilityState: true,
    main_title: 'Monitoring',
    other_title: '',
    custom_list: [],
    custom_list_tree: [],
    permissions: {},
    selftest_server: '185.25.60.63',
    modules: {},
    datetime_picker: null,
    comments_filters: {},
    version_monitoring_front: '',

    check_preload: ['updatePermissions']
  },
  getters: {
    getCommentsFilters: (state) => {
      return state.comments_filters
    },
    getDatetimePicker: (state) => {
      return state.datetime_picker
    },
    getModules: (state) => {
      return state.modules
    },
    getVersionMonitoringFront: (state) => {
      return state.version_monitoring_front
    },
    getAuth: (state) => {
      return state.auth
    },
    getLoadPage: (state) => {
      return state.load_page
    },
    getPermissions: (state) => {
      return state.permissions
    },
    getCustomList: (state) => {
      return state.custom_list
    },
    getCustomListTree: (state) => {
      return state.custom_list_tree
    },
    getUser: (state) => {
      return state.user
    },
    getSelfTestServers: (state) =>{
      return state.selftest_server
    }
  },
  mutations: {
    updateDatetimePicker (state, new_datetime_picker) {
      state.datetime_picker = new_datetime_picker
    },
    addPreloadItems (state, permissions) {
      if (permissions.includes('permissionSupport') || permissions.includes('permissionSupportAdmin')) {
        this.commit('startLoadItem', 'ticketInfo')
      }

      if (permissions.includes('viewSimcardProfile')) {
        this.commit('startLoadItem', 'groupSimcardProfileUpdate')
      }

      this.commit('startLoadItem', 'deviceGroupUpdate')
      this.commit('startLoadItem', 'customListUpdate')
      this.commit('startLoadItem', 'groupSimcardDevicesUpdate')
    },

    startLoadItem (state, name) {
      if (!state.check_preload.includes(name)) {
        state.check_preload.push(name)
      }
      this.dispatch(name)
    },

    customListUpdate (state, custom_list) {
      state.custom_list = custom_list

      let group = {}
      for(let i in state.custom_list) {
        group[state.custom_list[i].id] = { ...state.custom_list[i], label: state.custom_list[i].name, search_text: state.custom_list[i].name, isDefaultExpanded:true, expanded: true }
      }

      let root_group  = []

      for(let i in group) {
        root_group.push(group[i])
      }

      state.custom_list_tree = root_group
    },
    updatePermissions (state, permissions) {
      this.commit('addPreloadItems', permissions)

      let object = {}
      for (let permission of permissions) {
        object[permission] = true
      }
      state.permissions = object
    },
    updateCommentsFilters (state, new_filters) {
      state.comments_filters = new_filters
    },
    updateMainTitle (state, main_title) {
      state.main_title = main_title
    },
    updateOtherTitle (state, other_title) {
      state.other_title = other_title
    },
    updateVisibilityState (state, new_state) {
      state.visibilityState = new_state
    },
    updateAuth (state, auth) {
      state.auth = auth
    },
    updateModules (state, modules) {
      state.modules = modules
    },
    updateVersionMonitoringFront (state, version) {
      state.version_monitoring_front = version
    },
    updateUser (state, user) {
      state.user = user
    },
    updateLoadPages (state, value) {
      state.load_page = value
    },
    updateSelfTestServer(state, server) {
      state.selftest_server = server
    },
    logout (state) {
      state.servers = []
      state.permissions = {}
      state.check_preload = ['updatePermissions']
      state.auth = false
      location.reload(true)
    },
    deletePreloadName(state, name) {
      let index = state.check_preload.indexOf(name)
      if (index !== 0) {
        state.check_preload = state.check_preload.splice(index, 1)
      }else{
        state.check_preload = []
      }
    },
    startLoading(state){
      for (let name of state.check_preload) {
        this.commit('startLoadItem', name)
      }

      let timer = setInterval(() => {
        if (state.check_preload.length === 0) {
          this.commit('updateLoadPages', false)
          clearInterval(timer)
        }
      }, 100)
    }
  },
  actions: {
    async updatePermissions () {
      await Http.v1.getUserPermissions((response) => {
        this.commit('updatePermissions', response.data)
        this.commit('deletePreloadName', 'updatePermissions')
      })
    },
    async customListUpdate () {
      await Http.v1.getCustomListUser((response) => {
        this.commit('customListUpdate', response.data)
        this.commit('deletePreloadName', 'customListUpdate')
      })
    },

    startPreload() {
      this.commit('startLoading')
    }
  }
}
